package or.garden.manager.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class CreateIrrigationRequest(
    val bedId: Int,
    val nextIrrigationDate: String,
    val frequency: String
)

@Serializable
data class IrrigationResponse(
    val id: Int,
    val userId: Int,
    val bed: BedData,
    val nextIrrigationDate: String,
    val frequency: String,
    val urgent: Boolean = false,
    val humanNextDate: String = ""
)